import { CircularProgress, Container, Divider, IconButton, Typography } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Grid from '@material-ui/core/Grid';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon, MoreVert as MoreVertIcon, Search as SearchIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Date from "../../components/Form/Date";
import TextField from '../../components/Form/TextField';
import BoxSlide from '../../components/ui/BoxSlideUI';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { MDFe as MDFeInterface, MDFeSearch } from '../../interfaces/MDFe';
import { CollectionResponse } from '../../interfaces/ResponseInterface';
import MDFeApi from '../../services/MDFeApi';
import { MDFE_STATUS } from '../../utils/constants';
import utilsDate from '../../utils/Date';
import MDFeDetail from '../MDFeDetail';
import { StyledMenu, StyledMenuItem, useStyles } from './Style';

const MDFe: React.FC = () => {
    const classes = useStyles();
    const [mdfes, setmdfes] = useState<CollectionResponse | any>();
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [mdfeId, setMDFeId] = useState<number>(0);
    const [widthGrid, setWidthGrid] = useState("100%");
    const { user } = useAuth();
    const { t } = useTranslation("MDFe");
    const history = useHistory();
    const [openedPainel, setOpenedPainel] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(0);
    const [rowsPerPageOptions, setRowsPerPageOptions] = useState<number[]>([]);
    const [count, setCount] = useState(0);
    const [sort, setSort] = useState<string>('id');
    const [sortDir, setSortDir] = useState<string>('desc');
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [selectedMDFe, setSelectedMDFe] = useState<MDFeInterface>();

    const { enqueueSnackbar } = useSnackbar();
    const { handleSubmit, reset, control, getValues } = useForm<any>(
        {
            defaultValues: {
                mdfeKeyDescription: '',
                invoiceKeyNumber: '',
                beginIssueDate: null,
                endIssueDate: null,
                vehiclePlateNumber: '',
                sortDir: 'desc',
                sort: 'UpdatedAt'
            }
    })
    useEffect(() => {

        if (loading !== false) {

            var data = getValues();
            let finalData = data;

            finalData = Object.assign(data,
                {
                    companyId: user.company.companyID,
                    PageSize: rowsPerPage !== 0 ? rowsPerPage : 10,
                    PageIndex: page,
                    Sort: sort,
                    SortDir: sortDir
                });

            MDFeApi.searchMDFe(finalData as MDFeSearch)
                .then(result => {
                    if (result && result.items) {
                        setPage(result.pageIndex);
                        setRowsPerPage(result.pageSize);
                        setCount(result.totalCount);
                        let index = 1;
                        let rowsPerPageOptions = [];

                        while (index <= parseInt(String(result.totalCount / 10))) {
                            if (index < 10) {
                                rowsPerPageOptions.push(index * 10);
                                index += 1;
                            }
                            else {
                                rowsPerPageOptions.push(index * 10);
                                index += 10;
                            }
                        }

                        if ((result.totalCount % 10) !== 0) {
                            rowsPerPageOptions.push(result.totalCount);
                        }
                        setRowsPerPageOptions(rowsPerPageOptions);
                        setmdfes(result);
                    }
                    else {
                        setmdfes([]);
                    }
                }).catch(() => {
                    setmdfes([]);
                }).finally(() => {
                    setLoading(false);
                });

        }

    }, [loading]);

    const onSubmit = async() => { 
        setPage(0);
        setRowsPerPage(0);
        setLoading(true);
    }

    const callbackDialogHandle = () => {
        onSubmit();
    }

    function handleChangePage(newPage: number) {
        setPage(newPage);
        setLoading(true);
    }

    function handleChangeRowsPerPage(rowsPerPage: number) {
        setRowsPerPage(rowsPerPage);
        setPage(0);
        setLoading(true);
    }

    function handleSortClick(column: string, orderDirection: string) {
        setSort(`${orderDirection}`);
        setSortDir(`${orderDirection}`);
        setLoading(true);
    }

    function handleOpenPanelChange(id: any) {
        setMDFeId(id);
        setAnchorEl(null);
        setOpenedPainel(true);
        setWidthGrid("35%");
    }

    function handleClick(event: any, row: any) {
        setAnchorEl(event.currentTarget);

        let selecterMDFe = mdfes.items.filter(function (item: MDFeInterface) {
            return item.id === row;
        })[0];

        setSelectedMDFe(selecterMDFe)
    };

    const handleCancelMDFe = (mdfId: number) => {

        setOpenBackdrop(true)
        setAnchorEl(null)

        MDFeApi.cancelMDFe(mdfId).then((result) => {

            enqueueSnackbar(t("returnCancelMDFe"), { variant: 'success' });

        }).catch(() => {
        }).finally(() => {
            setOpenBackdrop(false);
        })

    }

    const handleTerminateMDFe = (mdfeId: number) => {

        setOpenBackdrop(true)
        setAnchorEl(null)

        MDFeApi.terminateMDFe(mdfeId).then((result) => {

            enqueueSnackbar(t("returnTerminadeMDFe"), { variant: 'success' });

        }).catch(() => {
        }).finally(() => {
            setOpenBackdrop(false)
        })

    }

    const downloadMDFeFile = (mdfeId: any) => {
        setOpenBackdrop(true);
        setAnchorEl(null);

        MDFeApi.getMDFeFile(mdfeId)
            .then((response) => {
                var file = new Blob([response.data], { type: 'application/pdf' });
                var fileURL = window.URL.createObjectURL(file);
                window.open(fileURL);
            }).finally(() => {
                setOpenBackdrop(false);
            });
    }

    const cleanFilters = () => {
        reset();
    };

    const renderButtons = (rowIndex: any) => {
        let selecterMDFe = mdfes.items[rowIndex];

        return (
            <div>
                <IconButton size='small' onClick={(event: any) => handleClick(event, selecterMDFe?.id)}>
                    <MoreVertIcon />
                </IconButton>
                <StyledMenu
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}>

                    <StyledMenuItem
                        disabled={!(selectedMDFe?.mdfeShipping?.fileName !== null)}
                        onClick={() => downloadMDFeFile(selectedMDFe?.id as number)}
                        style={{
                            minHeight: '48px',
                            display: "block"
                        }}
                    >
                        {t("downloadPDF")}
                    </StyledMenuItem>

                    <StyledMenuItem
                        disabled={!(selectedMDFe?.mdfeSituation === "AUT")}
                        onClick={() => handleTerminateMDFe(selectedMDFe?.id as number)}
                        style={{
                            minHeight: '48px',
                            display: "block"
                        }}
                    >
                        {t("terminate")}
                    </StyledMenuItem>

                    <StyledMenuItem
                        disabled={!(selectedMDFe?.mdfeSituation === "AUT")}
                        onClick={() => handleCancelMDFe(selectedMDFe?.id as number)}
                        style={{
                            minHeight: '48px',
                            display: "block"
                        }}
                    >
                        {t("cancel")}
                    </StyledMenuItem>

                </StyledMenu>
            </div>
        );
    }

    const columns = [
        {
            name: 'seriesNumber',
            label: String(t('seriesNumber'))
        },
        {
            name: 'mdfeKeyDescription',
            label: String(t('MDFeKeyDescription')),
        },
        {
            name: 'issueDate',
            label: String(t('IssueDate')),
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return value !== "0001-01-01T00:00:00" ? utilsDate.DateTime(value) : "";
                }
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: String(t('VehiclePlateNumber'))
        },
        {
            name: 'mdfeSituation',
            label: String(t('MDFeSituation')),
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {

                    let statusMDFE = MDFE_STATUS.filter(function (item: any) {
                        return item.code === value;
                    })[0];

                    return statusMDFE.label;
                }
            }
        },
        {
            name: 'mdfeErrorMessage',
            label: String(t('MDFeErrorMessage'))
        },
        {
            name: 'updatedBy',
            label: String(t('UpdatedBy'))
        },
        {
            name: 'updatedAt',
            label: String(t('UpdatedAt')),
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return value !== null ? utilsDate.DateTime(value) : "";
                }
            }
        },
        {
            name: "",
            options: {
                disableClick: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        padding: "0px 0px 0px 13px"
                    }
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowIndex)
                )
            }
        }
    ]

    const options = {
        sortOrder: { name: sort.split(':')[0], direction: sort.split(':')[1] } as any,
        textLabels: {
            body: {
                noMatch: 'Nenhum registro para exibir',
                toolTip: "",
            },
            pagination: {
                next: "Proxima",
                previous: "Anterior",
                rowsPerPage: "Linhas por pagina:",
                displayRows: "de",
            }
        }
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: mdfes?.items ? 'pointer' : ''
                },

            },
            MuiTableRow: {
                root: { '&$selected, &$selected:hover': { backgroundColor: '#d9e6f3', } }
            },
        }
    })

    return (
        <Container maxWidth={false} component="main">

            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <BoxSlide width='90%' isOpen={openedPainel} onClose={() => { setOpenedPainel(false); setWidthGrid("100%") }}>
                        <MDFeDetail 
                        mdfeId={mdfeId} 
                        traduction={useTranslation("MDFeDetail")} 
                        clickHandlerCalbkack={callbackDialogHandle}
                        clickHandlerClose={() => {
                            setOpenedPainel(false); 
                            setWidthGrid("100%")
                        }}
                        />
                    </BoxSlide>

                    
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <Grid container spacing={1}>
                            <Grid item xs={2} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearchMDFe")}
                                </Typography>
                            </Grid>

                            <Grid item xs={10} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI onClick={() => cleanFilters()} startIcon={<BackspaceOutlinedIcon />}>{t('buttonClean')}</ButtonUI>
                                <ButtonUI color="primary" startIcon={<AddIcon />} onClick={() => handleOpenPanelChange(0)}>{t('buttonAdd')}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{t('buttonSearch')}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={3}>
                                <TextField 
                                    fullWidth 
                                    inputProps={{ maxLength: 44 }}
                                    label={t('MDFeKeyDescription')} 
                                    name="mdfeKeyDescription" 
                                    control={control} 
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <TextField 
                                    fullWidth 
                                    inputProps={{ maxLength: 44 }}
                                    label={t('InvoiceKeyNumber')} 
                                    name="invoiceKeyNumber" 
                                    control={control}
                                />
                            </Grid>
                            <Grid item >
                                <Date label={t("BeginIssueDate")} name="beginIssueDate" control={control} fullWidth/>
                            </Grid> 
                            <Grid item >
                                <Date label={t("EndIssueDate")} name="endIssueDate" control={control} fullWidth/>
                            </Grid>  
                            <Grid item xs={2}>
                                <TextField 
                                    label={t("VehiclePlateNumber")} 
                                    name="vehiclePlateNumber" 
                                    control={control}
                                    mask="aaa9*99" 
                                    fullWidth/> 
                            </Grid>

                        </Grid>
                    </form>
                    <div style={{ maxWidth: widthGrid }}>
                        {loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={mdfes?.items}
                                    columns={columns}
                                    options={{
                                        ...options,
                                        page,
                                        count,
                                        rowsPerPage,
                                        rowsPerPageOptions,
                                        serverSide: true,
                                        pagination: mdfes?.items ? true : false,
                                        sort: mdfes?.items ? true : false,
                                        filter: false,
                                        search: false,
                                        print: false,
                                        viewColumns: false,
                                        onColumnSortChange: (changedColumn, direction) => {
                                            handleSortClick(changedColumn, direction);
                                        },
                                        onChangePage: (currentPage) => {
                                            handleChangePage(currentPage)
                                        },
                                        onChangeRowsPerPage: (numberOfRows) => {
                                            handleChangeRowsPerPage(numberOfRows);
                                        },
                                        onCellClick: (colData, { colIndex, rowIndex }) => {
                                            if ((mdfes && mdfes.items) && colIndex < 7) {
                                                handleOpenPanelChange(mdfes.items[rowIndex].id);
                                            }
                                        },
                                        
                                    }}
                                />
                            </MuiThemeProvider>
                        }
                    </div>
                </div>
            </div>
        </Container >
    )
}
export default MDFe;
